// extracted by mini-css-extract-plugin
module.exports = {"notification":"LogsErrorsIcon_notification__3wD1O"};